import { forwardRef } from 'react';

import { Clear as ClearIcon, Search as SearchIcon } from '@mui/icons-material';
import type { InputBaseProps } from '@mui/material';
import { IconButton, InputBase, styled } from '@mui/material';

import type { SearchBarProps } from 'common/viewcomp/inputs/hooks/useSearchBar';

interface Props extends Omit<InputBaseProps, 'onChange'> {
    searchBar: SearchBarProps;
    label?: string;
}

export const SearchBarOutlined = forwardRef(({ searchBar, label, ...props }: Props, ref) => {
    return (
        <Input
            value={searchBar.inputValue}
            onChange={(event) => searchBar.onChange(event.target.value)}
            placeholder={label}
            inputProps={{
                'aria-label': label,
            }}
            inputRef={ref}
            endAdornment={
                <>
                    {!searchBar.inputValue ? (
                        <IconButton aria-label={label}>
                            <SearchIcon />
                        </IconButton>
                    ) : (
                        <IconButton aria-label={label} onClick={searchBar.onClear}>
                            <ClearIcon />
                        </IconButton>
                    )}
                </>
            }
            {...props}
        />
    );
});

const Input = styled(InputBase)(({ theme }) => ({
    width: '100%',
    height: '32px',
    borderRadius: '4px',
    fontSize: '0.875rem',
    paddingInlineStart: '15px',

    border: `1px solid ${theme.ciPalette.border.lightGray}`,
    backgroundColor: theme.ciPalette.background.fullWhite,
}));
